/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>

(function($, _) {
  var ns = window.nspace("ccc.viz.selectors");

  ns.BreakdownSelectorView = ns.BaseSelectorView.extend({
    name: "Breakdown Selector",
    el: "#breakdown-selector",
    // templateSelector: "#breakdown-selector-template",
    template: _.template(
      [
        '<div class="filter-block breakdowns">',
        '<span class="filter-type-text">Breakdowns</span>',
        "<% for (var i = 0; i < indicators.length; i++) {",
        "var indicator = indicators[i];",
        'var vizIsMap = typeof ccc.viz.map != "undefined"',
        "var selectorInfo = selectors[indicator.id];",
        'var htmlId = _.str.sprintf("breakdown-%s", indicator.id); ',
        "%>",
        "<% if(selectorInfo.characteristics && vizIsMap){  %>",
        '<div class="filter-container expand">',
        "<%  } else{ %>",
        '<div class="filter-container">',
        "<%  } %>",
        "<% if (indicator.selected) { %>",
        '<input class="breakdown-radio" type="radio" name="breakdowns" id="<%=htmlId%>" value="<%=indicator.id%>" data-name="<%=selectorInfo.breakdown%>" checked  />',
        "<% }",
        "else { %>",
        '<input class="breakdown-radio" type="radio" name="breakdowns" id="<%=htmlId%>" value="<%=indicator.id%>" data-name="<%=selectorInfo.breakdown%>" />',
        "<% } %>",
        '<label for="<%=htmlId%>"><%=selectorInfo.breakdown%></label><br/>',
        "        ",
        "<% if (selectorInfo.characteristics) {",
        "var chs = selectorInfo.characteristics;",
        "%>",
        "        ",
        '<div class="generic-form-select characteristics">',
        "<% for (var j = 0; j < chs.length; j++) {",
        "var ch = chs[j];",
        "if (ch.selected) {",
        "%>",

        '<div class="radio-container"><input class="radioOpt" name="<%=htmlId%>" id="radio<%=ch.id%>" type="radio" value="<%=ch.id%>" checked data-text="<%=ch.name%>"><label class="radioLabel" for="radio<%=ch.id%>" ><%=ch.name%></label></div>',

        "<%  }",
        "else {",
        "%>",
        '<div class="radio-container"><input class="radioOpt" name="<%=htmlId%>" id="radio<%=ch.id%>" type="radio" value="<%=ch.id%>" data-text="<%=ch.name%>"><label class="radioLabel" for="radio<%=ch.id%>" ><%=ch.name%></label></div>',
        "<%  }",
        "} %>",
        "</div>",
        "<br/>",
        "<% } %>",
        "</div>",
        "<% } %>",
        "</div>",
        "<div>",
      ].join("\n"),
    ),
    propertyName: "indicatorId",

    initialize: function(options) {
      _.bindAll(this);
      this.hideCharacteristics = options.hideCharacteristics;
      this.model.on("after-change", this.updateDOM);
    },

    events: {
      change: "onChangeUpdateModel",
    },

    hasValueSet: function() {
      return (
        !!this.model.get(this.propertyName) &&
        !!this.model.get("characteristicId")
      );
    },

    onChangeUpdateModel: function(event) {
      //check for blank radio options
      if (
        $(".breakdown-radio:checked " + " ~ .generic-form-select input")
          .length &&
        $(".breakdown-radio:checked " + " ~ .generic-form-select input:checked")
          .length === 0
      ) {
        $(".breakdown-radio:checked  ~ .generic-form-select input:first").prop(
          "checked",
          true,
        );
      }
      // Indicator ID comes from the radio buttons
      var indId = $(".breakdown-radio:checked", this.$el).val();

      var chId;
      // Characteristic ID from the changed event source?
      if(event && event.srcElement && !event.srcElement.classList.contains("breakdown-radio")) {
        chId = event.srcElement.value;
      }
      else if (event && event.originalEvent && event.originalEvent.srcElement && !event.originalEvent.srcElement.classList.contains("breakdown-radio")) {
        chId = event.originalEvent.srcElement.value;
      }

      // Characteristic ID comes from the checkbox
      chId = chId || $(".breakdown-radio:checked ~ .generic-form-select input").filter(function() {
        return this.checked;
      }).first().val();

      var lastIndId = this.model.attributes.indicatorId;
      var lastChId = this.model.attributes.characteristicId;
      if (indId !== lastIndId || chId !== lastChId) {
        // Tracks when a user clicks on a "Breakdown" radio button on the "Explore Data" page
        var selectedTab = capitalizeFirstLetter(
          window.location.pathname.split("/")[2],
        ); // e.g. 'Map', 'Table', 'Bar chart' tab
        var selectedBreakdown = $(".breakdown-radio:checked", this.$el)
          .siblings("label")
          .text(); // distribution name
        var selectedCharacteristic = $(
          ".breakdown-radio:checked ~ .generic-form-select",
          this.$el,
        )
          .children('[value="' + chId + '"]')
          .data("text");

        dataLayer.push({
          event: "Breakdown Radio Button Clicks",
          eventCategory: "Interactive Clicks",
          eventAction:
            selectedTab +
            "|" +
            selectedBreakdown +
            "|" +
            selectedCharacteristic,
          eventLabel: window.location.pathname,
        });
      }

      var props = {
        characteristicId: chId,
      };
      props[this.propertyName] = indId;

      // Other selectors are indicator-specific and may need to update other model properties
      // in response to the indicator changing. In order to accomodate that, emit a "before-change"
      // event and pass along the new properties, allowing any handlers to modify the set of new
      // properties as needed. This will prevent multiple change events from firing in response to the
      // indicator changing.
      this.model.trigger("before-change", props);
      // Update the model
      this.model.set(props);

      // try to force setting the breakdown radio buttons
      this.model.trigger("after-change");
    },

    /**
     * Updates the model with default selections, for cases where the user arrives
     * at the page with nothing preselected.
     */
    initializeModel: function() {
      var self = this;

      // It's possible to arrive here with an indicator set, but a required characteristic is not.
      // Try to retain the indicator if it's already set.
      var indId = this.model.get(this.propertyName);

      var radioSelector = "input:radio[value='" + indId + "']";
      if (indId) {
        // Do we have a matching radio button?
        var $radioSelector = $(self.el).find(radioSelector);
        if ($radioSelector.length === 0) {
          selectFirstRadioButton(this.model, this.propertyName);
        }
        if (
          chId === undefined &&
          $(radioSelector + " ~ .generic-form-select input").length
        ) {
          $(radioSelector + " ~ .generic-form-select input:first").prop(
            "checked",
            true,
          );

          this.model.set(
            "characteristicId",
            $(radioSelector + " ~ .generic-form-select input:first").val(),
          );
        }
      }
      else {
        // Check if a radiobutton is already selected
        radioSelector = "input:checked:radio[name='breakdowns']";

        var $checkedBreakdownRadioButton = $(radioSelector);

        if ($checkedBreakdownRadioButton.length) {
          // Update the model to match the value of the selected radio button
          this.model.set(
            this.propertyName,
            $checkedBreakdownRadioButton.val(),
            { silent: true },
          );
        }
        else {
          selectFirstRadioButton(this.model, this.propertyName);
        }
      }
      // Do we have a matching selection in the characteristics dropdown?
      var chId = this.model.get("characteristicId");
      var $option = $(radioSelector + "~input[value='" + chId + "']", this.$el);
      if ($option.length === 0) {
        $option = $(".radioOpt[value=" + chId + "]");

        if ($option.length === 0) {
          var $selectedCharacteristicRadio = $(radioSelector + "~input");
          if (!$selectedCharacteristicRadio.length) {
            $selectedCharacteristicRadio = $(radioSelector + "~.characteristics input:checked:radio");
          }
          self.model.set("characteristicId", $selectedCharacteristicRadio.val(), {
            silent: true,
          });
        }
      }

      function selectFirstRadioButton(model, propertyName) {
        // No match? Update the model to match the value of the first radio button
        var val = $(self.el)
          .find("input:radio:first")
          .val();

        model.set(propertyName, val, { silent: true });

        var characteristics = Object.values(model.selectorInfo.selectors)[0].characteristics;
        if (characteristics instanceof Array && characteristics.length) {
          model.set("characteristicId", characteristics[0].id, { silent: true });
        }

        // console.log(Object.values());

        // Object.values(model.selectorInfo.selectors)[0].locationTypes.map(function(){})
      }
    },

    /**
     * Updates the DOM to match the selections specified on the model
     */
    updateDOM: function() {
      // Choose the radio button with the value specified in the model
      var radioSelector =
        ".breakdown-radio[value='" + this.model.get(this.propertyName) + "']";
      $(radioSelector).prop("checked", true);

      // Select the corresponding characteristic from the dropdown, too
      $(radioSelector +
          "~.generic-form-select input[value='" +
          this.model.get("characteristicId") +
          "']",
      ).prop("checked", true);
    },

    /**
     * Returns text summarizing the currently selected options for this selector.
     */
    getDataSummaryText: function() {
      // Don't include the selected value in the data summary if the control is hidden
      if (this.isHidden) {
        return null;
      }

      var radioSelector =
        ".breakdown-radio[value='" + this.model.get(this.propertyName) + "']";
      var distro = $(radioSelector, this.$el).data("name");
      var ch = $(
        radioSelector + "~.generic-form-select input:checked",
        this.$el,
      ).data("text");

      return _.str.isBlank(ch) ? distro : distro + ": " + ch;
    },

    showHideCharacteristicSelector: function() {
      // Show ONLY the characteristics for the currently selected breakdown
      $(".characteristics", this.el).hide();
      $("br", this.el).hide();

      var radioSelector =
        ".breakdown-radio[value='" + this.model.get(this.propertyName) + "']";
      $(
        radioSelector + " ~.characteristics, " + radioSelector + " ~br",
        this.el,
      ).show();

      //if filter has options show open
      $(".filter-container.expand.open").removeClass("open");
      if ($(radioSelector + "~.generic-form-select input").length) {
        $(radioSelector)
          .parents(".filter-container.expand")
          .addClass("open");
      }
    },

    render: function(selectorInfo) {
      // This selector only needs to be rendered once. After the first time, don't bother re-rendering
      if (this.isRendered) {
        if (!this.hideCharacteristics) {
          this.showHideCharacteristicSelector();
        }
        return;
      }

      // Call the base implementation
      ns.BreakdownSelectorView.__super__.render.call(this, selectorInfo);

      // Hide the characteristic dropdown if it's not configured to be shown
      if (this.hideCharacteristics) {
        $(".characteristics", this.el).hide();
        $("br", this.el).hide();
      }
      // Otherwise show only the characterstics for the current indicator
      else {
        this.showHideCharacteristicSelector();
      }

      // Don't bother rendering again
      this.isRendered = true;

      // Hide the selector if there is only a single indicator with no breakdown
      if (
        selectorInfo.indicators.length == 1 &&
        !selectorInfo.selectors[selectorInfo.indicators[0].id].characteristics
      ) {
        this.$el.hide();
        this.isHidden = true;
      }
    },
  });
})(jQuery, _);

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

(function($, _) {
  var ns = window.nspace("ccc.viz.selectors");

  // NOTE MultipleBreakdownSelectorViewBase is a legacy version of BreakdownSelectorView
  // we changed BreakdownSelectorView and it broke MultipleBreakdownSelectorView
  ns.MultipleBreakdownSelectorViewBase = ns.BaseSelectorView.extend({
    name: "Breakdown Selector",
    el: "#breakdown-selector",
    templateSelector: "#breakdown-selector-template",
    propertyName: "indicatorId",

    initialize: function(options) {
      _.bindAll(this);

      this.hideCharacteristics = options.hideCharacteristics;
    },

    events: {
      change: "onChangeUpdateModel",
    },

    hasValueSet: function() {
      return (
        !!this.model.get(this.propertyName) &&
        !!this.model.get("characteristicId")
      );
    },

    onChangeUpdateModel: function() {
      // Indicator ID comes from the radio buttons
      var indId = $("input:radio:checked", this.$el).val();

      // Characteristic ID comes from the checkbox
      var chId = $("input:radio:checked~select", this.$el).val();

      var lastIndId = this.model.attributes.indicatorId;
      var lastChId = this.model.attributes.characteristicId;
      if (indId !== lastIndId || chId !== lastChId) {
        // Tracks when a user clicks on a "Breakdown" radio button on the "Explore Data" page
        var selectedTab = capitalizeFirstLetter(
          window.location.pathname.split("/")[2],
        ); // e.g. 'Map', 'Table', 'Bar chart' tab
        var selectedBreakdown = $("input:radio:checked", this.$el)
          .siblings("label")
          .text(); // distribution name
        var selectedCharacteristic = $("input:radio:checked~select", this.$el)
          .children('[value="' + chId + '"]')
          .text();

        function capitalizeFirstLetter(string) {
          return string.charAt(0).toUpperCase() + string.slice(1);
        }

        dataLayer.push({
          event: "Breakdown Radio Button Clicks",
          eventCategory: "Interactive Clicks",
          eventAction:
            selectedTab +
            "|" +
            selectedBreakdown +
            "|" +
            selectedCharacteristic,
          eventLabel: window.location.pathname,
        });
      }

      var props = {
        characteristicId: chId,
      };
      props[this.propertyName] = indId;

      // Other selectors are indicator-specific and may need to update other model properties
      // in response to the indicator changing. In order to accomodate that, emit a "before-change"
      // event and pass along the new properties, allowing any handlers to modify the set of new
      // properties as needed. This will prevent multiple change events from firing in response to the
      // indicator changing.
      this.model.trigger("before-change", props);

      // Update the model
      this.model.set(props);
    },

    /**
     * Updates the model with default selections, for cases where the user arrives
     * at the page with nothing preselected.
     */
    initializeModel: function() {
      var self = this;

      // It's possible to arrive here with an indicator set, but a required characteristic is not.
      // Try to retain the indicator if it's already set.
      var indId = this.model.get(this.propertyName);

      var radioSelector = "input:radio[value='" + indId + "']";
      if (indId) {
        // Do we have a matching radio button?
        var $radioSelector = $(radioSelector);
        if ($radioSelector.length === 0) {
          selectFirstRadioButton(this.model, this.propertyName);
        }
      }
      else {
        // Check if a radiobutton is already selected
        radioSelector = "input:checked:radio[name='breakdowns']";
        var $checkedBreakdownRadioButton = $(radioSelector);
        if ($checkedBreakdownRadioButton.length) {
          // Update the model to match the value of the selected radio button
          this.model.set(
            this.propertyName,
            $checkedBreakdownRadioButton.val(),
            { silent: true },
          );
        }
        else {
          selectFirstRadioButton(this.model, this.propertyName);
        }
      }
      // Do we have a matching selection in the characteristics dropdown?
      var chId = this.model.get("characteristicId");
      var $option = $(
        radioSelector + "~select option[value='" + chId + "']",
        this.$el,
      );
      if ($option.length === 0) {
        self.model.set("characteristicId", $(radioSelector + "~select").val(), {
          silent: true,
        });
      }

      function selectFirstRadioButton(model, propertyName) {
        // No match? Update the model to match the value of the first radio button
        radioSelector = "input:radio:first";
        model.set(propertyName, $(radioSelector).val(), { silent: true });
      }
    },

    /**
     * Updates the DOM to match the selections specified on the model
     */
    updateDOM: function() {
      // Choose the radio button with the value specified in the model
      var radioSelector =
        "input:radio[value='" + this.model.get(this.propertyName) + "']";
      $(radioSelector).prop("checked", true);

      // Select the corresponding characteristic from the dropdown, too
      $(radioSelector + "~select").val(this.model.get("characteristicId"));
    },

    /**
     * Returns text summarizing the currently selected options for this selector.
     */
    getDataSummaryText: function() {
      // Don't include the selected value in the data summary if the control is hidden
      if (this.isHidden) {
        return null;
      }

      var radioSelector =
        "input:radio[value='" + this.model.get(this.propertyName) + "']";
      var distro = $(radioSelector, this.$el).data("name");
      var ch = $(radioSelector + "~select option:selected", this.$el).text();

      return _.str.isBlank(ch) ? distro : distro + ": " + ch;
    },

    showHideCharacteristicSelector: function() {
      // Show ONLY the characteristics for the currently selected breakdown
      $(".characteristics", this.el).hide();
      $("br", this.el).hide();

      var radioSelector =
        "input:radio[value='" + this.model.get(this.propertyName) + "']";
      $(
        radioSelector + " ~.characteristics, " + radioSelector + " ~br",
        this.el,
      ).show();
    },

    render: function(selectorInfo) {
      // This selector only needs to be rendered once. After the first time, don't bother re-rendering
      if (this.isRendered) {
        if (!this.hideCharacteristics) {
          this.showHideCharacteristicSelector();
        }
        return;
      }

      // Call the base implementation
      ns.BreakdownSelectorView.__super__.render.call(this, selectorInfo);

      // Hide the characteristic dropdown if it's not configured to be shown
      if (this.hideCharacteristics) {
        $(".characteristics", this.el).hide();
        $("br", this.el).hide();
      }
      // Otherwise show only the characterstics for the current indicator
      else {
        this.showHideCharacteristicSelector();
      }

      // Don't bother rendering again
      this.isRendered = true;

      // Hide the selector if there is only a single indicator with no breakdown
      if (
        selectorInfo.indicators.length == 1 &&
        !selectorInfo.selectors[selectorInfo.indicators[0].id].characteristics
      ) {
        this.$el.hide();
        this.isHidden = true;
      }
    },
  });
})(jQuery, _);
